import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postMetasDeAplicacaoDeRecurso = async (
  token: string,
  meta_execucao_fisico_id: number,
  tipo: string,
  etapa: number,
  fase: number,
  custo_unitario: number,
  unidade_medida: string,
  quantidade: number,
  especificacao: string,
  valor_parceiro_publico: number,
  valor_parceiro_privado: number
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/metas-de-aplicacao-de-recursos`,
    {
      meta_execucao_fisico_id,
      tipo,
      etapa,
      fase,
      custo_unitario,
      unidade_medida,
      quantidade,
      especificacao,
      valor_parceiro_publico,
      valor_parceiro_privado,
    },
    config
  );
  return response.data;
};
export default postMetasDeAplicacaoDeRecurso;
